module.exports = __webpack_public_path__ + "static/media/corr.cde5d080.jpg";